'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Parallax = function () {
    function Parallax(el) {
        _classCallCheck(this, Parallax);

        this.el = el;
        this.slides = this.el.querySelectorAll('.parallax-item');
        this.pagination = this.el.querySelector('.parallax-pagination');
        if (is.mobile()) {
            this.mobile();
        } else {
            this.desktop();
        }
        //events
        this.events();
    }

    _createClass(Parallax, [{
        key: 'events',
        value: function events() {}
    }, {
        key: 'mobile',
        value: function mobile() {
            this.slider = new Swiper(this.el, {
                wrapperClass: 'parallax-inner',
                slideClass: 'parallax-item',
                paginationModifierClass: 'parallax-pagination-',
                pagination: '.parallax-pagination',
                nextButton: '.parallax-button-next',
                prevButton: '.parallax-button-prev',
                autoHeight: true
            });
        }
    }, {
        key: 'desktop',
        value: function desktop() {
            var _this = this;

            this.monitor = scrollMonitor.create(this.el);
            this.monitor.fullyEnterViewport(function () {
                domUtils.addClass(_this.el, 'active');
            });
            this.monitor.partiallyExitViewport(function () {
                domUtils.removeClass(_this.el, 'active');
                _.each(_this.slides, function (sAll) {
                    _.delay(function(){
                        sAll.querySelector('.parallax-item-background').style = '';
                    }, 610);
                });
            });

            this.pages = [];

            domUtils.addClass(this.slides[0], 'active');
            _.each(this.slides, function (s, i) {
                var page = document.createElement('div');
                page.className = 'parallax-page';
                _this.pagination.appendChild(page);

                page.addEventListener('click', function (ev) {
                    ev.preventDefault();
                    $('html,body').animate({
                        scrollTop: $(s).offset().top
                    }, 1000);
                    return false;
                });

                var mnt = scrollMonitor.create(s, domUtils.getViewHeight() / 2);
                mnt.fullyEnterViewport(function () {
                    _.each(_this.slides, function (sAll) {
                        if (s != sAll) {
                            domUtils.removeClass(sAll, 'active');
                        }
                    });
                    domUtils.addClass(s, 'active');
                    _.each(_this.el.querySelectorAll('.parallax-page'), function (pAll) {
                        domUtils.removeClass(pAll, 'active');
                    });
                    domUtils.addClass(page, 'active');
                });
            });
        }
    }]);

    return Parallax;
}();

var init = function init() {
    var elements = document.querySelectorAll('.parallax');
    Array.prototype.forEach.call(elements, function (el, i) {
        new Parallax(el);
    });
};

domUtils.ready(init);
